import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles } from 'lucide-react';
interface BonusProps {
  number: string;
  title: string;
  image: string;
  description: string;
  value: string;
}
export function BonusCard({
  number,
  title,
  image,
  description,
  value
}: BonusProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} whileHover={{
    y: -10
  }} className="bg-white border-2 border-violet-100 rounded-3xl overflow-hidden flex flex-col shadow-lg hover:shadow-2xl hover:border-violet-200 transition-all duration-300 relative group" data-id="element-128">
      <div className="absolute top-4 right-4 z-20" data-id="element-129">
        <motion.div animate={{
        scale: [1, 1.1, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} className="bg-violet-600 text-white p-2 rounded-full shadow-lg" data-id="element-130">
          <Gift size={16} data-id="element-131" />
        </motion.div>
      </div>

      <div className="aspect-[4/3] overflow-hidden bg-violet-50 relative" data-id="element-132">
        <img src={image} alt={title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-133" />
        <div className="absolute inset-0 bg-gradient-to-t from-violet-950/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-134" />
      </div>

      <div className="p-8 flex-grow flex flex-col relative" data-id="element-135">
        <div className="flex items-center gap-2 mb-3" data-id="element-136">
          <span className="bg-violet-100 text-violet-600 font-black text-[10px] px-3 py-1 rounded-full uppercase tracking-widest" data-id="element-137">
            BONO {number}
          </span>
          <Sparkles size={14} className="text-yellow-500 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-138" />
        </div>

        <h3 className="text-xl font-black text-violet-950 mb-4 leading-tight group-hover:text-violet-600 transition-colors" data-id="element-139">
          {title}
        </h3>
        <p className="text-violet-800/70 text-sm mb-6 flex-grow" data-id="element-140">
          {description}
        </p>
        <div className="pt-4 border-t border-violet-50" data-id="element-141">
          <p className="text-violet-300 text-xs line-through" data-id="element-142">
            VALORADO EN {value}
          </p>
          <p className="text-violet-600 font-black text-lg" data-id="element-143">HOY GRATIS</p>
        </div>
      </div>
    </motion.div>;
}